import { Badge } from "@/components/ui/badge";

interface InvoiceStatusBadgeProps {
  statusName?: string;
  isOverdue?: boolean;
}

const normalizeStatus = (value: string) =>
  value.trim().toLowerCase().replace(/\s|_/g, "");

const statusVariant = (statusName?: string): "default" | "secondary" | "destructive" | "outline" => {
  const normalized = normalizeStatus(statusName ?? "");

  if (normalized === "paid") return "secondary";
  if (normalized === "void" || normalized === "disputed") return "destructive";
  if (normalized === "partiallypaid") return "outline";
  if (normalized === "issued" || normalized === "approved") return "default";

  return "outline";
};

export const InvoiceStatusBadge = ({
  statusName,
  isOverdue = false,
}: InvoiceStatusBadgeProps) => {
  if (isOverdue) {
    return <Badge variant="destructive">Overdue</Badge>;
  }

  const normalized = normalizeStatus(statusName ?? "");

  if (normalized === "pendingvoid") {
    return (
      <Badge className="border-orange-400 bg-orange-100 text-orange-700 hover:bg-orange-100">
        Pending Void
      </Badge>
    );
  }

  return <Badge variant={statusVariant(statusName)}>{statusName ?? "Unknown"}</Badge>;
};
